module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/meditation-on-beach-c600ba1e71b13b08804af59edcf4de8c.jpeg";